import { Form } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Input from '@/atoms/input';
import { FilterComponentInput } from '@core/offices/types';

const FilterInputEmail = (props: FilterComponentInput) => {
  const { t } = useTranslation();
  return (
    <Form.Item
      rules={[
        {
          type: 'email',
          message: t('personalInfo.validation.emailInvalid'),
        },
      ]}
      label={props.filter.label}
    >
      <Input value={props.value} type="email" {...props} onChange={(e) => props.handleChange(e.target.value)} />
    </Form.Item>
  );
};
export default FilterInputEmail;
